module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"display_by_product":"상품별 리뷰 보기","search_placeholder":"리뷰 키워드 검색"}}')
  delete Component.options._Ctor
}
